var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconThetaAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_215",
    "data-name": "Group 215",
    transform: "translate(-11143.333 -2998)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70",
    "data-name": "Rectangle 70",
    width: 60,
    height: 60,
    transform: "translate(11143.333 2998)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M11187.148,3054.4h-27.631l-2.673-2.674v-47.446l2.673-2.674h27.631l2.673,2.674v47.446Zm-24.956-5.347h22.281v-42.1h-22.281Z",
    fill: "#18c99d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    width: 16.325,
    height: 5.348,
    transform: "translate(11165.171 3020.553)",
    fill: "#18c99d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 5.347,
    height: 8.422,
    transform: "translate(11170.659 3032.855)",
    fill: "#18c99d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    width: 5.347,
    height: 7.391,
    transform: "translate(11170.659 3015.065)",
    fill: "#18c99d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    width: 16.325,
    height: 5.348,
    transform: "translate(11165.171 3030.44)",
    fill: "#18c99d"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThetaAi);
export default __webpack_public_path__ + "static/media/icon-theta-ai.65ea68abfecd2580175394f634ada01e.svg";
export { ForwardRef as ReactComponent };